import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeCardNumberComponent, StripeService } from 'ngx-stripe';
import { CacheService } from 'src/app/services/cache.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { DataService } from 'src/app/services/data.service';
import { UrlConstants } from 'src/app/services/url-constants';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-change-payment-mode',
  templateUrl: './change-payment-mode.component.html',
  styleUrls: ['./change-payment-mode.component.scss']
})
export class ChangePaymentModeComponent implements OnInit {
  @ViewChild(StripeCardNumberComponent) card: any = StripeCardNumberComponent;
  public cardOptions: StripeCardElementOptions = this.constants.SRIPE_CARD_STYLE;
  public elementsOptions: StripeElementsOptions = { locale: 'en' };
  public isloading = false;
  public foundError = false;
  public stripeTest: any = UntypedFormGroup;
  public user = {
    given_name: ''
  }
  success = null;
  public errorMessage = ''
  stripeCustomerId: any;

  screenHeight: number;
  screenWidth: number;
  windowWidth: string;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 658 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `calc(${this.screenHeight}px - 100px )`;
    }
  }
  constructor(
    private fb: UntypedFormBuilder,
    public constants: ConstantsService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticate: CacheService,
    public userService: UserService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private stripeService: StripeService,
  ) { }

  ngOnInit(): void {
    this.authcall();
    this.stripeTest = this.fb.group({ name: ['', [Validators.required]] });
    this.onResize();
  }

  cancelClick() {
    this.router.navigate(['/user-setting/all-access']), { relativeTo: this.route };
  }
  public async authcall() {
    // Get current user data from db for get the email and name
    this.authenticate.getAuthUser()
      .then(async (data) => {
        this.user.given_name = data.given_name;
        await this.userService.getUser(false).then(res => {
          this.stripeCustomerId = res.stripe_customer_id;

        })
      })
  }
  createCard() {
    let checkCardError = (this.card.stripeElementRef.nativeElement).getAttribute("class")
    let { given_name } = this.user;
    if (checkCardError.includes(this.constants.EMPTY_TXT)) {
      this.foundError = true;
      this.errorMessage = this.constants.ENTER_CARD_TXT
    }
    else {
      let name = this.stripeTest.get('name').value;
      name === '' ? name = given_name : name = name;
      this.isloading = true;
      this.foundError = false;
      this.stripeService.createToken(this.card.element, { name })
        .subscribe((result) => {
          if (result.token) {
            this.addCard(result['token'].id);
          }
          if (result['error']) {
            this.isloading = false;
            this.foundError = true;
            this.errorMessage = result['error'].message;
            this.success = false;
            setTimeout(() => {
              this.success = null;
            }, 5000);
          }
        }, err => {
          // console.log(err);
        })
    }
  }

  async addCard(token) {
    const params = [
      { param: '{actionName}', value: 'addCard' }
    ]
    const postdata = {
      "stripe_customer_id": this.stripeCustomerId,
      "card_ele": token
    }
    await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata)
      .subscribe(async (data) => {
        this.success = true;
        this.isloading = false;
        this.stripeTest.reset();
        setTimeout(() => {
          this.success = null;
        }, 5000);
        this.router.navigate(['/user-setting/all-access']), { relativeTo: this.route };
      }, err => {
        this.isloading = false;
        this.success = false;
        this.errorMessage = 'Rejected'
        // console.log(err);
        setTimeout(() => {
          this.success = null;
        }, 5000);
      })
  }
}
